"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var native_1 = __importDefault(require("styled-components/native"));
var ThemeProvider_1 = require("../theme/ThemeProvider");
var ATLAtomButton_1 = require("../atoms/ATLAtomButton");
var react_native_1 = require("react-native");
var ButtonTypeEnum_1 = require("../enums/ButtonTypeEnum");
var defaultProps = {
    complementary: false,
    disabled: false,
    type: ButtonTypeEnum_1.ButtonTypeEnum.default,
    buttonBaseProps: {},
};
// STYLED COMPONENTS ---------------------------------------------------------------------------------------------------
exports.ButtonWrapper = native_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding:  ", "px\n            ", "px;\n"], ["\n  padding:  ", "px\n            ", "px;\n"
    // COMPONENT -----------------------------------------------------------------------------------------------------------
])), function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.verticalMargin || atlTheme.SpacingBase;
}, function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.horizontalMargin || atlTheme.SpacingButtonMarginHorizontal;
});
// COMPONENT -----------------------------------------------------------------------------------------------------------
exports.ATLButton = function (_a) {
    var icon = _a.icon, title = _a.title, onPress = _a.onPress, complementary = _a.complementary, disabled = _a.disabled, type = _a.type, horizontalMargin = _a.horizontalMargin, verticalMargin = _a.verticalMargin, buttonBaseProps = _a.buttonBaseProps;
    var theme = ThemeProvider_1.useTheme();
    var renderButton = function () { return (react_1.default.createElement(ATLAtomButton_1.ATLAtomButton, __assign({ icon: icon, title: title, onPress: onPress, disabled: disabled, type: type, borderColor: complementary ? theme.ColorComplementary1 : theme.ColorBrand1Default, borderRadius: theme.BorderRadiusButton, borderWidth: theme.BorderWidthButton, buttonColor: complementary ? theme.ColorComplementary1 : theme.ColorBrand1Default, buttonHeight: theme.HeightButtonBase, disabledOpacity: theme.OpacityDisabled, iconSize: theme.FontSizeButton + 4, iconPadding: theme.SpacingBase, fontFamily: theme.FontFamilySystem, fontSize: theme.FontSizeButton, fontWeight: theme.FontWeightStrong, textCase: theme.TextCaseButton, textColorRegular: complementary ? theme.ColorBrand1Default : theme.ColorComplementary1, textColorComplementary: complementary ? theme.ColorComplementary1 : theme.ColorBrand1Default }, buttonBaseProps))); };
    // Returns complete ATLButton
    return (react_1.default.createElement(exports.ButtonWrapper, { horizontalMargin: horizontalMargin, verticalMargin: verticalMargin }, renderButton()));
};
exports.ATLButton.defaultProps = defaultProps;
exports.ATLButton.displayName = 'ATLButton';
var templateObject_1;
